module.exports = __webpack_public_path__ + "static/03-277581e32133d513cbb4e16a5fa67130.jpg";